import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ManageListing.css';

// Components
import SideMenu from '../../components/ManageListing/SideMenu';
import PanelWrapper from '../../components/ManageListing/PanelWrapper';
import Loader from '../../components/Loader';

// GraphQL
import { withQuery } from '../../hoc/withGraphql';
import ManageListingsQuery from './manageListing.graphql';

const ManageListing = ({ ManageListingsData }) => {
  const { ManageListings, loading } = ManageListingsData || {};

  return (
    <Grid fluid className="dashBoardContainer">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="dashBoardListingGrid">
            <SideMenu />
            <div>
              {!ManageListings && <Loader type="text" />}
              {ManageListings && <PanelWrapper data={ManageListingsData} />}
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

ManageListing.propTypes = {
  ManageListingsData: PropTypes.shape({
    loading: PropTypes.bool,
    ManageListings: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ])
  })
};

ManageListing.defaultProps = {
  ManageListingsData: {
    loading: true,
    ManageListings: []
  }
};

export default compose(
  withStyles(s),
  withQuery(ManageListingsQuery, {
    name: 'ManageListingsData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(ManageListing);